import {
  FlowRegistrationInfo,
  GameSectionImageOverlay,
  GlobalState,
  InstantWinData,
  MetricData,
  ReplacementTags
} from '@/store/modules/global/state';
import { DeviceTypes } from '@/typings/enums/enums';
import { MutationTree } from 'vuex';
import { AddonEditItem } from '@/typings/interfaces/data/campaign';

export type Mutations = {
  setMetricData(state: GlobalState, payload: MetricData): void;
  setReplacementTags(state: GlobalState, payload: ReplacementTags): void;
  setGameWinner(state: GlobalState, payload: boolean): void;
  setGameEnded(state: GlobalState, payload: boolean): void;
  setAddonsData(state: GlobalState, payload: Record<string, AddonEditItem>): void;
  setCurrentDevice(state: GlobalState, payload: DeviceTypes): void;
  setInstantWinData(state: GlobalState, payload: InstantWinData): void;
  setStaticFormData(state: GlobalState, payload: Record<string, string>): void;
  setFlowRegistrationInfo(state: GlobalState, payload: FlowRegistrationInfo): void;
  setGameSectionImageOverlay(state: GlobalState, payload: GameSectionImageOverlay): void;
  setGameTestDate(state: GlobalState, payload: Date): void;
  setMountedSection(state: GlobalState, payload: number): void;
  setMountedFlowPage(state: GlobalState, payload: number): void;
  removeMountedSection(state: GlobalState, payload: number): void;
  removeMountedFlowPage(state: GlobalState, payload: number): void;
};

export const mutations: MutationTree<GlobalState> & Mutations = {
  setMetricData: (state, payload) => {
    const currentMetricData = state.metricData;
    state.metricData = { ...currentMetricData, ...payload };
  },

  setReplacementTags: (state, payload) => {
    const currentReplacementTagsData = state.replacementTags;
    state.replacementTags = {
      ...currentReplacementTagsData,
      ...payload
    };
  },

  setInstantWinData: (state, payload) => {
    state.instantWinData = payload;
  },

  setGameData: (state, payload) => {
    const currentGameData = state.gameData;
    state.gameData = { ...currentGameData, ...payload };
  },

  setGameWinner: (state, payload) => {
    state.gameWinner = payload;
  },
  setGameEnded: (state, payload) => {
    state.gameEnded = payload;
  },
  setAddonsData: (state, payload) => {
    state.addonsData = payload;
  },
  setCurrentDevice: (state, payload) => {
    state.currentDevice = payload;
  },
  setStaticFormData: (state, payload) => {
    state.staticFormData = payload;
  },
  setStaticQueryParams: (state, payload) => {
    state.staticQueryParams = payload;
  },
  setFlowRegistrationInfo: (state, payload) => {
    state.flowRegistrationInfo = payload;
  },
  setGameSectionImageOverlay: (state, payload) => {
    state.gameSectionImageOverlay = payload;
  },
  setGameTestDate(state, payload) {
    state.gameTestDate = payload;
  },
  setMountedSection(state, payload: number) {
    state.mountedSections.push(payload);
  },
  setMountedFlowPage(state, payload: number) {
    state.mountedFlowPages.push(payload);
  },
  removeMountedSection(state, payload: number) {
    state.mountedSections = state.mountedSections.filter((sectionId) => sectionId !== payload);
  },
  removeMountedFlowPage(state, payload: number) {
    state.mountedFlowPages = state.mountedSections.filter((flowpageId) => flowpageId !== payload);
  }
};
